
import api from "../utils/api";

export const getEmails = async (username) => {
    try {
        const response = await api.get(`/get_emails?username=${encodeURIComponent(username)}`);
        return response.data;
    } catch (error) {
        console.error("Get emails error:", error);
        throw error;
    }
};

export const addEmail = async (username, email, branch) => {
    try {
        const response = await api.post("/add_email", {
            username,
            email,
            branch,
        });
        return response.data;
    } catch (error) {
        console.error("Add email error:", error);
        throw error;
    }
};

export const updateEmail = async (username, oldEmail, newEmail) => {
    try {
        const response = await api.post("/update_email", {
            username,
            old_email: oldEmail,
            new_email: newEmail,
        });
        return response.data;
    } catch (error) {
        console.error("Update email error:", error);
        throw error;
    }
};


export const deleteEmail = async (username, email, branch) => {
    try {
        const response = await api.delete(`/delete_email`, {
            params: { username, email, branch }
        });
        return response.data;
    } catch (error) {
        console.error("Delete email error:", error);
        throw error;
    }
};

// ---------------------------------
// Report Windows Management
// ---------------------------------

export const getReportWindows = async (username) => {
    try {
        const response = await api.get(`/get_report_windows?username=${encodeURIComponent(username)}`);
        return response.data;
    } catch (error) {
        console.error("Get report windows error:", error);
        throw error;
    }
};

export const addReportWindow = async (username, start, end) => {
    try {
        const response = await api.post("/add_report_window", {
            start,
            end,
        }, {
            params: { username }
        });
        return response.data;
    } catch (error) {
        console.error("Add report window error:", error);
        throw error;
    }
};

export const deleteReportWindow = async (username, start, end) => {
    try {
        const response = await api.delete("/delete_report_window", {
            data: { start, end },
            params: { username }
        });
        return response.data;
    } catch (error) {
        console.error("Delete report window error:", error);
        throw error;
    }
};

export const editReportWindow = async (username, oldStart, oldEnd, newStart, newEnd) => {
    try {
        const response = await api.put("/edit_report_window", {
            old_start: oldStart,
            old_end: oldEnd,
            new_start: newStart,
            new_end: newEnd
        }, {
            params: { username }
        });
        return response.data;
    } catch (error) {
        console.error("Edit report window error:", error);
        throw error;
    }
};

// ---------------------------------
// Energy Efficiency Report Schedule
// ---------------------------------

export const getEnergyEfficiencySchedule = async (username) => {
    try {
        const response = await api.get(
            `/energy-efficiency-schedule?username=${encodeURIComponent(username)}`,
        );
        return response.data?.schedule || [];
    } catch (error) {
        console.error("Get energy efficiency schedule error:", error);
        throw error;
    }
};

export const saveEnergyEfficiencySchedule = async (username, schedule) => {
    try {
        // Grouped-by-branch shape (same as the daily report):
        //   [{ branch, emails, days, windows: [{ start, end }] }]
        // last_sent is stripped — the backend manages send timestamps per window.
        const response = await api.post("/energy-efficiency-schedule", {
            username,
            schedule: cleanBranchSchedule(schedule),
        });
        return response.data;
    } catch (error) {
        console.error("Save energy efficiency schedule error:", error);
        throw error;
    }
};

// ---------------------------------
// Energy (Daily) Report Schedule — column `daily_report_email` on client_profiles
// ---------------------------------
// Grouped shape consumed by enviz_email.py:
//   [{ branch, emails: [...], days: [...], windows: [{ start, end, last_sent }] }]
// "branch" targets a branch/main node ("ALL" = Main / whole system); "days" are
// days-of-month; times are 24-hour "HH:MM".
//
// NOTE (frontend-only): the GET/POST /daily-report-email routes still need to be
// added on enviz_api. Until then getDailyReportSchedule returns [] and saving
// surfaces an error.

// Normalize an editor schedule into the payload shape (strip transient fields).
const cleanBranchSchedule = (schedule) =>
    (schedule || []).map(({ branch, emails, days, windows }) => ({
        branch: branch || "ALL",
        emails: emails || [],
        days: Array.isArray(days) ? days : [],
        windows: (windows || []).map(({ start, end }) => ({ start, end })),
    }));

export const getDailyReportSchedule = async (username) => {
    try {
        const response = await api.get(
            `/daily-report-email?username=${encodeURIComponent(username)}`,
        );
        return response.data?.schedule || [];
    } catch (error) {
        console.error("Get daily report schedule error:", error);
        return []; // backend endpoint not present yet — start empty
    }
};

export const saveDailyReportSchedule = async (username, schedule) => {
    try {
        const response = await api.post("/daily-report-email", {
            username,
            schedule: cleanBranchSchedule(schedule),
        });
        return response.data;
    } catch (error) {
        console.error("Save daily report schedule error:", error);
        throw error;
    }
};
